class ReturnModal {

    constructor(_window, _document, _config, _onfinished) {
        this.window = _window;
        this.config = _config;
        this.document = _document;
        this.onfinished = _onfinished;
    
        var susppend_data = this.window.scorm.get('cmi.suspend_data');
        var lesson_location = this.window.scorm.get('cmi.core.lesson_location');

        if(susppend_data != null && susppend_data != "" && susppend_data != undefined && susppend_data != "{}" || lesson_location != null && lesson_location != "" && lesson_location != undefined){
            this.addModal();
        }
        else{
            this.onfinished();
        }
    }
    
    addModal() {
        var objConfig = this.config.modalVoltar;
        $(this.document.body).append(
            `<div class="returnModal"> 
                <div class="confirmBox"> 
                <svg tabindex="-1" class="svg-icon" style="color:${objConfig.color} ;padding-bottom: 0.9rem; width: 5rem; height: 5rem;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M512 298.666667a42.666667 42.666667 0 0 0-42.666667 42.666666v170.666667a42.666667 42.666667 0 0 0 85.333334 0V341.333333a42.666667 42.666667 0 0 0-42.666667-42.666666z m39.253333 367.786666a32.426667 32.426667 0 0 0-3.84-7.68l-5.12-6.4a42.666667 42.666667 0 0 0-46.506666-8.96 49.066667 49.066667 0 0 0-14.08 8.96A42.666667 42.666667 0 0 0 469.333333 682.666667a42.666667 42.666667 0 0 0 3.413334 16.213333 38.4 38.4 0 0 0 23.04 23.04 40.106667 40.106667 0 0 0 32.426666 0 38.4 38.4 0 0 0 23.04-23.04A42.666667 42.666667 0 0 0 554.666667 682.666667a58.026667 58.026667 0 0 0 0-8.533334 27.306667 27.306667 0 0 0-3.413334-7.68zM512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z m0 768a341.333333 341.333333 0 1 1 341.333333-341.333333 341.333333 341.333333 0 0 1-341.333333 341.333333z"  /></svg>
                <h1 tabindex="1"> ${objConfig.msg} </h1>
                <div class="buttons"> 
                        <button tabindex="2" aria-label="${objConfig.yes}" id="confirm_rt">${objConfig.yes}</button>
                        <button tabindex="3" aria-label="${objConfig.no}" id="noconfirm_rt">${objConfig.no}</button> 
                </div>
                </div>
            </div>`
        );

        var _this = this;

        $(this.document.body).find(".returnModal").find("#confirm_rt").click(function() {
            $(_this.document.body).find(".returnModal").fadeOut();
            _this.onfinished();
        });

        $(this.document.body).find(".returnModal").find("#noconfirm_rt").click(function() {
            localStorage.clear();
            _this.window.scorm.set('cmi.suspend_data', "{}");
            _this.window.scorm.set('cmi.core.lesson_location', "");
            _this.onfinished();
            // _this.window.navigate.goto(_this.config.pages[0].uid);
            $(_this.document.body).find(".returnModal").fadeOut();
            
        });

        $(this.document.body).find(".returnModal").find("button").css("background-color", objConfig.color);
        
        
    };
  

}